import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { SeasonsList } from "@/components/settings/seasons-list";
import { can } from "@/lib/session";

const adminRoute = getRouteApi("/admin");

function SeasonsPage() {
  const { session } = adminRoute.useRouteContext();

  return (
    <div className="mx-auto w-full max-w-3xl">
      <SeasonsList
        canDelete={can(session, "seasons:delete")}
        canEdit={can(session, "seasons:write")}
      />
    </div>
  );
}

export const Route = createFileRoute("/admin/seasons")({
  component: SeasonsPage,
  head: () => ({ meta: [{ title: "Seasons" }] }),
});
